// extracted by mini-css-extract-plugin
export default {"perk":"service-creation-perk-item_perk__-ujws","icon":"service-creation-perk-item_icon__Yfku9"};